
	import LoadingComponent from "custom/LoadingComponent"
	import Component from "vue-class-component"
	import PButton from "@portal-components/ui/input/PButton.vue"
	import CompanyAddressForm from "./CompanyAddressForm.vue"
	import { Company, Address } from "store/company/types"
	import { StoreAction } from "@lib/types/vuex"
	import toaster from "@portal-components/ui/utils/toaster"
	import { companyModule } from "store/modules"

	@Component({
		components: {
			PButton,
			CompanyAddressForm
		}
	})
	export default class MyCompany extends LoadingComponent {
		@companyModule.Getter company!: Company
		@companyModule.Action updateCompanyDetails!: StoreAction<Company>

		readonly baseTranslationKey = "profile.myCompany"

		get businessAddress(): Address | undefined {
			return this.company.address?.business
		}

		get postalAddress(): Address | undefined {
			return this.company.address?.postal
		}

		async changeCompanyDetails(): Promise<void> {
			try {
				await this.manageLoadingState(this.updateCompanyDetails({
					...this.company,
					address: {
						business: !this.businessAddress || this.addressHasEmptyField(this.businessAddress) ? {} : this.businessAddress,
						postal: !this.postalAddress || this.addressHasEmptyField(this.postalAddress) ? {} : this.postalAddress
					}
				}))

				toaster.success({ title: `${ this.baseTranslationKey }.success` })
			} catch (error) {
				toaster.error({ title: `${ this.baseTranslationKey }.error` })
			}
		}

		private addressHasEmptyField(address: Address): boolean {
			return !address.street || !address.number || !address.postalCode || !address.city
		}
	}
